var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAffiReason8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1093_1267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 13V18C20 18.7957 19.6839 19.5587 19.1213 20.1213C18.5587 20.6839 17.7957 21 17 21H13V13H20ZM11 13V21H7C6.20435 21 5.44129 20.6839 4.87868 20.1213C4.31607 19.5587 4 18.7957 4 18V13H11ZM9 2C9.56759 1.99933 10.1288 2.11976 10.6461 2.35325C11.1635 2.58674 11.625 2.92792 12 3.354C12.375 2.92792 12.8365 2.58674 13.3539 2.35325C13.8712 2.11976 14.4324 1.99933 15 2H15.5C15.8978 2 16.2794 2.15804 16.5607 2.43934C16.842 2.72065 17 3.10218 17 3.5V4C17 4.729 16.805 5.412 16.465 6H19C19.5304 6 20.0391 6.21072 20.4142 6.58579C20.7893 6.96086 21 7.46957 21 8V10C21 10.364 20.903 10.706 20.732 11H13V8C13 7.73479 12.8946 7.48043 12.7071 7.2929C12.5196 7.10536 12.2652 7 12 7C11.7348 7 11.4804 7.10536 11.2929 7.2929C11.1054 7.48043 11 7.73479 11 8V11H3.268C3.09201 10.6962 2.99954 10.3511 3 10V8C3 7.46957 3.21072 6.96086 3.58579 6.58579C3.96086 6.21072 4.46957 6 5 6H7.535C7.18345 5.39217 6.99888 4.70218 7 4V3.5C7 3.10218 7.15804 2.72065 7.43934 2.43934C7.72065 2.15804 8.10218 2 8.5 2H9ZM9 4C9 4.53044 9.21072 5.03914 9.58579 5.41422C9.96086 5.78929 10.4696 6 11 6C11 5.46957 10.7893 4.96086 10.4142 4.58579C10.0391 4.21072 9.53044 4 9 4ZM15 4C14.4696 4 13.9609 4.21072 13.5858 4.58579C13.2107 4.96086 13 5.46957 13 6C13.5304 6 14.0391 5.78929 14.4142 5.41422C14.7893 5.03914 15 4.53044 15 4Z",
    fill: "#741FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1093_1267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiReason8);
export default __webpack_public_path__ + "static/media/affiReason8.5693b88b9ef52dea022e266026b64905.svg";
export { ForwardRef as ReactComponent };